export default "__VITE_ASSET__2NCnrCJ3__"